export const getWrapInfo = (wrapWidth: number, wrapHeight: number) => {
  const wrapW = Number(wrapWidth); // 图片宽度
  const wrapH = Number(wrapHeight);// 图片高度
  const dW = 220; // 默认展示图片宽度，如果是竖图，则宽度固定是220，高度根据图片比例计算
  const dH = 160; // 默认展示图片高度，如果是横图，则高度固定是160，宽度根据图片比例计算
  const type = wrapW / wrapH > 1.25 ? 'horizontal' : 'vertical';

  if (type === 'vertical') {
    return {
      width: dW,
      height: dW * (wrapH / wrapW),
      type: 'vertical',
    };
  }

  return {
    width: dH * (wrapW / wrapH),
    height: dH,
    type: 'horizontal',
  };
};
